import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuggestionModal = ({
  isOpen,
  onClose,
  blockTitle,
  suggestions,
  onAccept,
  onReject,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-2xl bg-card rounded-xl elevation-2xl overflow-hidden max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
              <Icon name="Sparkles" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
                AI Suggestions
              </h2>
              <p className="text-xs md:text-sm text-muted-foreground font-caption">
                {blockTitle}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-smooth"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="p-6">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-4" />
              <p className="text-sm text-muted-foreground font-body">
                Generating AI suggestions...
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              {suggestions?.map((suggestion, index) => (
                <div
                  key={index}
                  className="p-4 bg-muted/50 border border-border rounded-lg transition-smooth hover:elevation-sm"
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                      <span className="text-sm font-medium text-primary font-caption">
                        {index + 1}
                      </span>
                    </div>
                    <p className="flex-1 text-sm text-foreground font-body leading-relaxed">
                      {suggestion}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 ml-11">
                    <Button
                      variant="default"
                      size="sm"
                      onClick={() => onAccept(suggestion)}
                      iconName="Check"
                      iconPosition="left"
                      iconSize={14}
                    >
                      Accept
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onReject(index)}
                      iconName="X"
                      iconPosition="left"
                      iconSize={14}
                    >
                      Reject
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="mt-6 p-4 bg-accent/10 border border-accent/20 rounded-lg">
            <div className="flex items-start gap-3">
              <Icon name="Lightbulb" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-muted-foreground font-caption">
                These suggestions are generated based on your industry and business type. You can accept them directly or use them as inspiration to craft your own content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuggestionModal;